module.exports = "/packs/media/images/ScenarioChart-20f7c7078980235a1244c2fba1a19986.png";